<template>
  <div>
    <template v-for="(item, index) in routes">
      <el-submenu :index="String(item.id)" v-if="!!item.id" :key="item.id">
        <template slot="title">
          <i
            ref="globalPoint"
            v-if="!Number(item.id)"
            class="el-icon-location"
          ></i>
          <div
            @click="onClick(item)"
            :key="'routes' + index"
            :class="{ inlineBlockGlobal: !Number(item.id) }"
          >
            <span :class="{ abcd: selfAreaId == item.id, dark:dark }"
              >{{ getNameLength(item.areaName, 7)
              }}{{ Number(item.id) ? `(${item.siteCount || 0})` : "" }}</span
            >
          </div>
        </template>
        <template v-show="!!item.child">
          <template v-for="(child, index) in item.child">
            <sidebar-item2
            :dark='dark'
              class="menu-indent"
              v-if="child.child"
              :routes="[child]"
              :key="'sitem' + index"
            ></sidebar-item2>
            <el-menu-item
              v-if="!child.child"
              :index="String(child.id)"
              :key="'rlink' + index"
            >
              <div @click="onClick(child)" :key="'routes' + index">
                <span
                  >{{ getNameLength(child.areaName, 5) }}({{
                    child.siteCount || 0
                  }})</span
                >
              </div>
            </el-menu-item>
          </template>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import store from "@/store";
import { mapGetters } from "vuex";
import { getHash } from "@/utils/tools";
import Api from "@/api";

export default {
  name: "SidebarItem2",
  props: {
    routes: {
      type: Array,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["areaLevel", "currpath", "user", "selfAreaId", "userLevel"]),
    rootPath() {
      return `/${this.currpath.split("/")[1]}`;
    },
  },
  data() {
    return {
      timer: null,
      debounceTimer: null,
    };
  },
  created() {
    const vm = this;
    setTimeout(() => {
      const point = vm.$refs.globalPoint;
      if (
        point &&
        point[0] &&
        point[0].parentElement &&
        point[0].parentElement.children &&
        point[0].parentElement.children[2]
      ) {
        point[0].parentElement.children[2].style.display = "none";
      }
    }, 1000);
  },
  methods: {
    getNameLength(name, num) {
      if (!name) return name;
      return name && name.length > num ? name.slice(0, num) + "..." : name;
    },
    onClick(item) {
      //防抖处理
      this.debounce(this.onclick2, this, null, item);
    },
    onclick2(item) {
      const vm = this;
      console.log("sideBar2 onclick", item);
      // if (!item.child || (item.child && !item.child.length)) {
      location.hash = getHash(item.id);
      // 清空原始的非法车辆
      const illegalBikes = {
        key: "illegalBikes",
        value: [],
      };
      store.commit("user/setUserInfo", illegalBikes);
      const userId = {
        key: "selfAreaId",
        value: item.id,
      };
      store.commit("user/setUserInfo", userId);
      const level = {
        key: "level",
        value: item.level,
      };
      store.commit("user/setUserInfo", level);
      const userAddress = {
        key: "selfAddress",
        value: item.areaName,
      };
      store.commit("user/setUserInfo", userAddress);
      // 站点管理展示的 平台编号
      const platformCodeParams = {
        key: "platformCode",
        value: item.platformCode,
      };
      store.commit("user/setUserInfo", platformCodeParams);
      // 是否是复合区子集
      // aggregation=1 标识复合区
      // aggregation=0 标识实体区
      // aggregation=0&aggregation_id!="" 标识实体区隶属于复合区
      // aggregation=0&aggregation_id=""  标识正常实体区
      let isAggregation = false;
      if (item.aggregation === 0) {
        isAggregation = true;
      }
      const aggregationParam = {
        key: "isAggregation",
        value: isAggregation,
      };
      store.commit("user/setUserInfo", aggregationParam);
      // // 保存当前用户选择的地址信息
      const userSelectAddressData = {
        key: "userSelectAddressData",
        value: item,
      };
      store.commit("user/setUserInfo", userSelectAddressData);
      const getCompanyParams = {
        selfAreaId:
          item && item.aggregation === 0 && item.aggregationId
            ? item.aggregationId
            : this.selfAreaId,
      };
      store.dispatch("globalVariable/getCompany", getCompanyParams);
      vm.getCompany(item);
    },
    // 初始化
    debounce(method, context, delay, params) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(function () {
        method.call(context, params);
      }, delay || 1500);
    },
    asyncApi(item) {
      const vm = this;
      vm.getCompany(item);
      try {
        if (
          vm.$parent.$parent.$parent.$parent.$parent.$refs["app-main"] &&
          vm.$parent.$parent.$parent.$parent.$parent.$refs["app-main"].$parent
            .$refs.abnormalHistory
        ) {
          vm.$parent.$parent.$parent.$parent.$parent.$refs[
            "app-main"
          ].$parent.$refs.abnormalHistory.initData();
        }
      } catch (err) {
        console.log("abnormalHistory-refresh", err);
      }
    },
    getMsgCounts() {
      if (this.userLevel >= 2) {
        const vm = this;
        const params = {
          selfAreaId: vm.selfAreaId,
        };
        Api.getMsgCounts(params).then((res) => {
          if (res.code === 200) {
            vm.siteMessageLength = res.data;
            const userSiteMessageLength = {
              key: "siteMessageLength",
              value: vm.siteMessageLength,
            };
            store.commit("user/setUserInfo", userSiteMessageLength);
          } else {
            vm.$message.warning(res.message);
          }
        });
      } else {
        const userSiteMessageLength = {
          key: "siteMessageLength",
          value: 0,
        };
        store.commit("user/setUserInfo", userSiteMessageLength);
      }
    },
    getCompany(item) {
      const vm = this;
      const params = {};
      params.selfAreaId =
        item && item.aggregation === 0 && item.aggregationId
          ? item.aggregationId
          : this.selfAreaId;
      Api.getEnterpriseList(params).then((res) => {
        if (res.code === 200) {
          // vm.tableData = res.data.lists
          const brands = JSON.parse(JSON.stringify(res.data.lists));
          if (brands && brands.length) {
            brands.forEach((item) => {
              item.key = item.brandId;
              item.value = item.brandName;
            });
            store.commit("globalVariable/save", {
              key: "brands",
              value: brands,
            });
          } else {
            store.commit("globalVariable/save", {
              key: "brands",
              value: [],
            });
          }
        } else {
          vm.$message.warning(res.message);
        }
      });
    },
    getMsg() {
      if (this.userLevel >= 2) {
        const vm = this;
        const params = {
          selfAreaId: vm.selfAreaId,
        };
        Api.getMsg(params).then((res) => {
          if (res.code === 200) {
            const historyData =
              res.data.lists && res.data.lists.length > 5
                ? res.data.lists.slice(0, 4)
                : res.data.lists;
            const historyDataRes = {
              key: "historyData",
              value: historyData,
            };
            store.commit("user/setUserInfo", historyDataRes);
          } else {
            vm.$message.warning(res.message);
          }
        });
      } else {
        const historyDataRes = {
          key: "historyData",
          value: [],
        };
        store.commit("user/setUserInfo", historyDataRes);
      }
    },
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
  components: {},
};
</script>

<style lang="less" scoped>
.svg-icon {
  margin-right: 10px;
}

.hideSidebar .menu-indent {
  display: block;
  text-indent: 10px;
}
.inlineBlockGlobal {
  display: inline-block;
  width: 90%;
}

.abcd {
  color: #1890ff;
  &.dark{
  color: #00dada !important;
  }
}
</style>
